import React, { PureComponent } from 'react';
import TranslatedCopy from '../../intl/translated-copy';
import sesion from '../../../images/img_profile/ICONO_SESION.png';

class ModalProfileOffline extends PureComponent {
  constructor() {
    super();
    this.state = {
      showHamburger: false,
    };
  }

  render() {
    return (
      <div className='Modal'>
        <div className='Modal-inner Modal-inner--USER_PROFILE_OFFLINE'>
          <div className='Modal-overlay Modal-overlay--isOpen Modal-overlay--USER_PROFILE_OFFLINE'></div>
          <div className='Modal-body Modal-body--isOpen Modal-body--regular Modal-body--USER_PROFILE_OFFLINE height-modal'>
            <div className='Modal-topBar'>
              <button className='Modal-close Icon Icon--xThin' onClick={this.props.closeModal}></button>
            </div>
            <div className='Modal-content Modal-content--USER_PROFILE_OFFLINE'>
              <div className='ProfileOffline'>
                <div className='ProfileOffline-wrapper'>
                  <div className='ProfileOffline-container'>
                    <div className='ProfileOfflineModal-element1'>
                      <img className='ResponsiveImage ProfileOffline-image' src={ sesion }/>
                    </div>
                    <div className='ProfileOfflineModal-element2'>
                      <TranslatedCopy
                        copyID='PROFILE_OFFLINE_TITLE'
                        className='profileOffline-title'
                        tagName='h3'/>
                      <div className='ProfileOfflineContentDescription'>
                        <TranslatedCopy
                          copyID='PROFILE_OFFLINE_COMPLETE_DESCRIPTION'
                          className='profileOffline-text'
                          tagName='span' />
                      </div>
                    </div>
                  </div>
                  <div className='ProfileOffline-exitButton'>
                    <button className='Btn Btn--filledRed Btn--small' onClick={this.props.closeModal}>
                      <TranslatedCopy
                        copyID='PROFILE_EXIT_OFFLINE'
                        tagName='span' />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ModalProfileOffline;
